<template>
  <div class="modal" tabindex="-1" id="citesModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <ModalTitleComponent title="CITES" />
        <div class="modal-body">
          <p>
            Some of the woods I use — such as grenadilla (African blackwood) —
            are protected under CITES, the Convention on International Trade in
            Endangered Species of Wild Fauna and Flora. I source all such wood
            legally and can document its origin.
          </p>
          <p>
            However, I do not ship instruments made from CITES-protected wood to
            countries outside the EU: doing so would require export permits that
            are not practical for individual, hand-made instruments. If you are
            based outside the EU, we can simply choose a non-CITES wood for your
            instrument — just get in touch.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import ModalTitleComponent from "@/components/util/ModalTitleComponent.vue";

export default {
  name: "CitesComponent",
  components: { ModalTitleComponent },
};
</script>
